import React, { useEffect, useState } from 'react';
import CloudStorage from '../../../../../CloudStorage/CloudStorage';
import useChatNavigation from '../../../../Common/useChatNavigation';
import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from 'react-redux';
import { getRentalRequestById } from '../../../../../redux/rental/action';
import { getSaleRequestById } from '../../../../../redux/sale/action';
import { getOTSByIdRequest } from '../../../../../redux/ots/action';
import { addpresent } from '../../../../Common/FewCommonMethods';
import { Commas, getDateFormate, getDeadlineDate } from '../../../../Common/AllDateTimeReleventFormate';
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import CustomReactQuillDescription from '../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription';
import ImageWithFallback from '../../../../../common/ImageWithFallback';
import ConfirmModal from "../../../../Common/ConfirmModal";
import { penaltytips } from '../../../../Common/Tooltips/tooltip';
import { decodeHtml } from '../../../../../assests/extention/commonfunction';

export default function OTSViewModel({ data, setviewModel, reject, accept, type, your }) {
    const { letChat } = useChatNavigation();
    const [orderdetails, setorderdetails] = useState([]);
    const [confirmDeclineModal, setConfirmDeclineModal] = useState(false);
    const dispatch = useDispatch();

    const bxp = useSelector(({ ots: { getotsbyid } }) => getotsbyid);
    const sale = useSelector(({ sale: { getsalerequestbyid } }) => getsalerequestbyid);
    const rental = useSelector(({ rental: { getrentalrequestbyid } }) => getrentalrequestbyid);

    useEffect(() => {
        if (type) {
            methodforalltypedata();
        }
    }, [data, type]);

    useEffect(() => {
        if (type == 1) {
            setorderdetails(bxp);
        } else if (type == 2) {
            setorderdetails(sale);
        } else if (type == 3) {
            setorderdetails(rental);
        }
    }, [bxp, sale, rental, type]);

    const methodforalltypedata = () => {
        if (type == 1) {
            dispatch(getOTSByIdRequest(data?.id));
        } else if (type == 2) {
            dispatch(getSaleRequestById(data?.id));
        } else if (type == 3) {
            dispatch(getRentalRequestById(data?.id));
        } else {
            return null;
        }
    };

    const formatTime = (time) => {
        const [hour, minutes] = time.split(":");
        const date = new Date();
        date.setHours(hour, minutes);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    };


    return (
        <div className='ots-view'>
            <div className="modal-content">
                <div className='modal-heading'>
                    <h6>Order no. : #{orderdetails?.id}</h6>
                    <a
                        onClick={() => {
                            setviewModel((state) => !state);
                        }}
                        className="btn close-button"
                    >
                        <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
                            alt=""
                        />
                    </a>
                </div>
                <div className="pending-left">
                    <ImageWithFallback url={Array.isArray(orderdetails?.files) ? orderdetails?.files[0]?.file : orderdetails?.cover} />
                    <div>
                        <h5>{decodeHtml(orderdetails?.title)}</h5>
                        <h3>$ {Commas(orderdetails?.price)}</h3>
                    </div>
                </div>
                <div className='ordered-by'>
                    <h6>{data?.is_mine == 0 ? '' : ''}</h6>
                    <div className='order-section1'>
                        <div className="pending-center">
                            <img src={data?.profile_image ? data.profile_image : ProfilePic} alt="" />
                            <div>
                                <p>{(data?.is_mine == 0 && type == 3) ? "Owner" : (data?.is_mine == 0 ? 'Seller' : 'Ordered by')}
                                    <p><img src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`} alt="" /> {decodeHtml(data?.country_title)}</p>
                                </p>
                                <h5>{decodeHtml(data?.first_name)} {decodeHtml(data?.last_name)}</h5>
                            </div>
                        </div>
                        <button className='buttons border-button' onClick={() => letChat(data)} >
                            <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" /> {data?.is_mine == 0 ? 'Chat With Seller' : 'Chat With Buyer'}
                        </button>
                    </div>
                    <h6>Order date</h6>
                    <h5>{getDateFormate(orderdetails?.created_on)}</h5>
                </div>
                {
                    type == 1 && (
                        <>
                            {Array.isArray(orderdetails?.milestones) && orderdetails?.milestones?.length > 0 ? <></> :
                                <div className="expert-sub-sec">
                                    <h6>Deadline</h6>
                                    <h5>{getDeadlineDate(orderdetails?.duration_type, orderdetails?.duration)}</h5>
                                </div>
                            }
                            <div className="expert-sub-sec">
                                <h6>Service details</h6>
                                <CustomReactQuillDescription value={orderdetails?.description} />
                            </div>
                            <div className="expert-sub-sec">
                                {Array.isArray(orderdetails?.milestones) && orderdetails?.milestones?.length > 0 && (
                                    <div className="lang-sec ">
                                        <h6>Milestones</h6>
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <th>Milestones</th>
                                                    <th>Deadline</th>
                                                    <th>Amount</th>
                                                    <th>
                                                        Penalty  &nbsp;
                                                        <img
                                                            data-tooltip-id="my-tooltip-1"
                                                            src={`${CloudStorage.cloudurl}/Assets/Images/project/penalty.svg`}
                                                            alt=""
                                                        />
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    {orderdetails?.milestones.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}. {decodeHtml(item.title)}</td>
                                                            <td>{item.duration ? item.duration : "-----"} {' '}
                                                                {item?.duration_type == 2 ? "Days" :
                                                                    item?.duration_type == 3 ? "Weeks" :
                                                                        item?.duration_type == 4 ? "Months" : ""}
                                                            </td>
                                                            <td>{item.amount ? "$" : ""}{item.amount ? Commas(item.amount) : "-----"}</td>
                                                            <td>{item.penalty ? addpresent(item.penalty) : "-----"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )
                }
                {
                    type == 2 && (
                        <>
                            <div className="expert-sub-sec">
                                <h6>Product details</h6>
                                <CustomReactQuillDescription value={orderdetails?.description} />
                            </div>
                            <div className="expert-sub-sec">
                                <h5>Shipping</h5>
                                <h6>{orderdetails?.shipping == 2 ? 'Not Included' : 'Included'}</h6>
                            </div>
                            <div className="expert-sub-sec">
                                <h5>Condition</h5>
                                <h6>{orderdetails?.product_condition == 2 ? 'Used' : 'Brand New'}</h6>
                            </div>
                        </>
                    )
                }
                {
                    type == 3 && (
                        <>
                            <div className="expert-sub-sec">
                                <h6>Rent duration (in UTC)</h6>
                                <h5>From {getDateFormate(orderdetails?.start_date)},  {orderdetails?.start_time && formatTime(orderdetails?.start_time)}</h5>
                                <h5>To {getDateFormate(orderdetails?.end_date)},  {orderdetails?.end_time && formatTime(orderdetails?.end_time)}</h5>
                            </div>
                            <div className="expert-sub-sec">
                                <h6>Product details</h6>
                                <CustomReactQuillDescription value={orderdetails?.description} />
                            </div>
                            <div className="expert-sub-sec">
                                <h5>Availability</h5>
                                <h6>Available {orderdetails?.rental_type == 2 ? 'With Interpreter' : 'Rental Only'}</h6>
                            </div>
                        </>
                    )
                }
                {
                    your == 'no' ? '' :
                        <div className="modal-buttons">
                            <button className='buttons border-button' onClick={() => setConfirmDeclineModal(true)}>Decline</button>
                            <button className='buttons background-button' onClick={() => { reject() }}>Accept</button>
                        </div>
                }
            </div>


            <Tooltip
                id="my-tooltip-1"
                place="bottom"
                content={penaltytips}
            />

            <ConfirmModal
                isOpen={confirmDeclineModal}
                toggle={() => setConfirmDeclineModal(false)}
                title="Confirm Decline"
                message="Are you sure you want to decline this request? This action cannot be undone."
                onConfirm={() => {
                    setConfirmDeclineModal(false);
                    accept();
                }}
            />
        </div>

    );
}
